import React, { createContext, useEffect, useState } from "react";
import { useFetcher } from "rest-hooks";
import { PublicSettingsResource } from "../api";
export const LoadSettingContext = createContext(undefined);
export const LoadSettingContextProvider = ({ settings, children }) => {
    const [data, setData] = useState(undefined);
    const fetchData = useFetcher(PublicSettingsResource.list());
    useEffect(() => {
        fetchData({}).then((data) => {
            if (data.length > 0) {
                setData(data.filter(e => settings.includes(e.key)));
            }
        });
    }, [setData, fetchData, settings]);
    return React.createElement(LoadSettingContext.Provider, { value: data }, children);
};
//# sourceMappingURL=LoadSettingContext.js.map